export default __webpack_public_path__ + "static/media/icon-coin-zil.581330c2.svg";